import Api from '.';

/**
 * Retrieve all HealthProfessionAssociation.
 */
export function listHealthProfessionAssociation() {
  return Api.get('/health-profession-association');
}
